module.exports = __webpack_public_path__ + "static/img/14.d695323.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12/4/1/14.png
// module id = cM5+
// module chunks = 2